module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmsdetail",
    staticStyle: {
      "background": "#f9f9f9",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "cart default"
  }, [_c('div', {
    staticClass: "cart-list"
  }, [_c('div', {
    staticClass: "cart-list-address"
  }, [_c('div', {
    staticClass: "default-t",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("收货人信息")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.add_address_visible = true
      }
    }
  }, [_vm._v("新增地址")])], 1), _vm._v(" "), _c('div', {
    staticClass: "address-row"
  }, [_c('div', [_vm._v(_vm._s(_vm.address_row.name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v("(" + _vm._s(_vm.address_row.phone) + ")")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.address_row.province) + " " + _vm._s(_vm.address_row.city) + " " + _vm._s(_vm.address_row.county) + " " + _vm._s(_vm.address_row.address))])]), _vm._v(" "), _c('div', {
    staticClass: "address-solid"
  }), _vm._v(" "), (!_vm.check_address_visible) ? _c('div', {
    staticClass: "address-more-box",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.check_address_visible = true
      }
    }
  }, [_c('span', {
    staticClass: "address-more"
  }, [_vm._v("更多地址")]), _vm._v(" "), _c('b', {
    staticClass: "address-more-icon"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.addressList), function(item, i) {
    return (_vm.check_address_visible) ? _c('div', [_c('div', {
      staticClass: "address-item-row",
      on: {
        "click": function($event) {
          return _vm.onAddressCheck(item)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-right": "20px"
      }
    }, [_vm._v("(" + _vm._s(item.phone) + ")")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.province) + " " + _vm._s(item.city) + " " + _vm._s(item.county) + " " + _vm._s(item.address))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.check_address_visible) ? _c('div', {
    staticClass: "address-souqi-box",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.check_address_visible = false
      }
    }
  }, [_c('span', {
    staticClass: "address-souqi"
  }, [_vm._v("收起地址")]), _vm._v(" "), _c('b', {
    staticClass: "address-souqi-icon"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "default-t"
  }, [_vm._v("确认订单")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goods_items,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "cart-product-img",
          attrs: {
            "src": scope.row.pic_url,
            "alt": "",
            "srcset": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": " ",
      "width": "320"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "p1 show-two-row"
        }, [_vm._v(_vm._s(scope.row.title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "show-two-row"
        }, [_vm._v(_vm._s(scope.row.sku.sku_formart))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "default"
        }, [_vm._v("单价:¥" + _vm._s(scope.row.price))]), _vm._v(" "), _c('p', {
          staticClass: "default"
        }, [_vm._v("数量:" + _vm._s(scope.row.count))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('b', {
          staticClass: "default"
        }, [_vm._v("\n                小记:\n                "), _c('span', {
          staticStyle: {
            "color": "#0175c2"
          }
        }, [_vm._v("¥" + _vm._s((scope.row.price) * scope.row.count))])])]
      }
    }])
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "pay-box"
  }, [_c('div', {
    staticClass: "pay-items-box"
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请输入其他诉求"
    },
    model: {
      value: (_vm.formData.note),
      callback: function($$v) {
        _vm.$set(_vm.formData, "note", $$v)
      },
      expression: "formData.note"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "items-1 flex-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "msg default"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "jsy-zhifu"
  }, [_c('table', {
    staticClass: "zhifu-table default",
    attrs: {
      "width": "400"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v(_vm._s(_vm.goods_items.length) + "种商品，总商品金额：")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "width": "200"
    }
  }, [_c('p', [_vm._v("\n                  ¥\n                  "), _c('span', {
    attrs: {
      "id": "moneys"
    }
  }, [_vm._v(_vm._s(_vm.goods_price))])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("运费：")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', [_vm._v("¥"), _c('a', {
    attrs: {
      "id": "yhmoney"
    }
  }, [_vm._v(_vm._s(_vm.express_price))])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("应支付金额：")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', [_c('span', [_vm._v("\n                    ¥\n                    "), _c('a', {
    attrs: {
      "id": "money"
    }
  }, [_vm._v(_vm._s(_vm.pay_price))])])])])])]), _vm._v(" "), (!_vm.pay_loading) ? _c('div', {
    staticClass: "jsy-zf"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.orderPay
    }
  }, [_vm._v("立即支付")])]) : _vm._e(), _vm._v(" "), (_vm.pay_loading) ? _c('div', {
    staticClass: "jsy-zf"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("获取信息中...")])]) : _vm._e()])])]), _vm._v(" "), (_vm.pay_visible) ? _c('div', {
    staticClass: "pay-ye-box"
  }, [_c('div', {
    staticClass: "pay-ye"
  }, [_c('p', {
    staticClass: "pay-box-title default"
  }, [_vm._v("订单支付")]), _vm._v(" "), _c('p', {
    staticClass: "pay-price default"
  }, [_vm._v("¥" + _vm._s(_vm.pay_price))]), _vm._v(" "), (_vm.selectedPayType == 'balance' && _vm.havePayPassword == true) ? _c('el-input', {
    attrs: {
      "placeholder": "请输入密码",
      "show-password": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPayType == 'balance' && _vm.havePayPassword == false) ? _c('el-input', {
    attrs: {
      "placeholder": "请设置支付密码",
      "show-password": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPayType == 'balance' && _vm.havePayPassword == false) ? _c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "请再次输入支付密码",
      "show-password": ""
    },
    model: {
      value: (_vm.password2),
      callback: function($$v) {
        _vm.password2 = $$v
      },
      expression: "password2"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('span', {
    staticClass: "pay-button",
    on: {
      "click": _vm.balancePay
    }
  }, [_vm._v("确认支付")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('p', {
    staticClass: "not-pay",
    on: {
      "click": _vm.notPay
    }
  }, [_vm._v("取消支付")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('el-button', {
    staticClass: "pay-button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    }
  }, [_vm._v("正在支付")]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.add_address_visible) ? _c('div', {
    staticClass: "add-address-box"
  }, [_c('div', {
    staticClass: "add-address-box-form"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "default",
    staticStyle: {
      "padding-left": "20px",
      "font-size": "18px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("新增地址")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v)
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "phone", $$v)
      },
      expression: "ruleForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地区选择",
      "prop": "area_key"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "props": {
        label: 'title'
      },
      "options": _vm.areaOptions
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.area_key),
      callback: function($$v) {
        _vm.area_key = $$v
      },
      expression: "area_key"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.address),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "address", $$v)
      },
      expression: "ruleForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认地址",
      "prop": "is_default"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.ruleForm.is_default),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "is_default", $$v)
      },
      expression: "ruleForm.is_default"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.add_address_visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('ElPayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "goods",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69f78dd7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/order/OrderPay.vue
// module id = 1270
// module chunks = 0